import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { focusStyle } from '../styles/mixins';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    '& .MuiInputLabel-root': {
      display: 'none',
    },
    '& .MuiInputAdornment-root': {
      marginLeft: 0,
      height: 56,
      display: 'block',
      marginTop: 0,
      maxHeight: 56,
    },
    '& .MuiOutlinedInput-root': {
      height: 56,
      borderRadius: 8,
      padding: 0,
      minWidth: 170,
      border: `1px solid ${theme.color.greys[40]}`,
    },
    '& .MuiOutlinedInput-input': {
      padding: 16,
    },
    '& .Mui-focused': {
      ...focusStyle(theme),
      borderRadius: 8,
    },
  },
  currencySuffix: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    borderLeft: `1px solid ${theme.color.greys[40]}`,
    alignSelf: 'stretch',
    margin: 0,
  },
}), { name: 'CurrencyInput', index: StylesIndexInjections.UI_MOLECULES });
